var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "approval" }, [
    _c(
      "div",
      { staticClass: "content" },
      [
        _c(
          "el-form",
          {
            ref: "formApproval",
            attrs: {
              size: "mini",
              model: _vm.approvalModel,
              "label-width": "100px"
            },
            nativeOn: {
              submit: function($event) {
                $event.preventDefault()
              }
            }
          },
          [
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "审批名称",
                  prop: "approvalName",
                  rules: _vm.rules.approvalName
                }
              },
              [
                _c("el-input", {
                  staticStyle: { width: "300px" },
                  attrs: { placeholder: "请输入审批名称" },
                  model: {
                    value: _vm.approvalModel.approvalName,
                    callback: function($$v) {
                      _vm.$set(_vm.approvalModel, "approvalName", $$v)
                    },
                    expression: "approvalModel.approvalName"
                  }
                })
              ],
              1
            ),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "审批类型",
                  prop: "approvalType",
                  rules: _vm.rules.approvalType
                }
              },
              [
                _c(
                  "el-radio-group",
                  {
                    model: {
                      value: _vm.approvalModel.approvalType,
                      callback: function($$v) {
                        _vm.$set(_vm.approvalModel, "approvalType", $$v)
                      },
                      expression: "approvalModel.approvalType"
                    }
                  },
                  [
                    _c("el-radio", { attrs: { label: 1 } }, [
                      _vm._v("顺序审批（按先后顺序审批）")
                    ]),
                    _c("el-radio", { attrs: { label: 2 } }, [
                      _vm._v("会审 （无顺序，全员通过则通过）")
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _c("el-form-item", { attrs: { label: "审批流程", required: "" } }, [
              _c(
                "div",
                { staticStyle: { display: "inline", position: "relative" } },
                [
                  _c(
                    "div",
                    { staticClass: "flow-sty" },
                    [
                      _vm._l(_vm.flows, function(user) {
                        return _c("div", { key: user.emplId }, [
                          _c("div", { staticClass: "men-item" }, [
                            _c("img", {
                              attrs: {
                                src: "/images/web/p-default.png",
                                width: "50px",
                                height: "50px",
                                alt: ""
                              }
                            }),
                            _c(
                              "span",
                              {
                                staticClass: "name-warp",
                                attrs: { title: user.name }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(user.name) +
                                    "\n                "
                                )
                              ]
                            ),
                            _c("span", {
                              staticClass: "item-close close_icon",
                              on: {
                                click: function($event) {
                                  return _vm.delUser(user)
                                }
                              }
                            })
                          ]),
                          _c("i", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.approvalModel.approvalType === 1,
                                expression: "approvalModel.approvalType === 1"
                              }
                            ],
                            staticClass: "icon icon-audit-jiantou32",
                            staticStyle: { width: "30px" }
                          })
                        ])
                      }),
                      _c(
                        "el-popover",
                        { attrs: { placement: "right" } },
                        [
                          _c("div", { staticStyle: { padding: "20px" } }, [
                            _c(
                              "p",
                              { staticStyle: { "margin-bottom": "20px" } },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { width: "125px" },
                                    attrs: { size: "mini" },
                                    on: { click: _vm.addManager }
                                  },
                                  [_vm._v("添加直属部门主管")]
                                )
                              ],
                              1
                            ),
                            _c(
                              "p",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { width: "125px" },
                                    attrs: { size: "mini" },
                                    on: { click: _vm.handleClickFlowPlus }
                                  },
                                  [_vm._v("选择成员")]
                                )
                              ],
                              1
                            )
                          ]),
                          _c("plus", {
                            attrs: { slot: "reference" },
                            slot: "reference"
                          })
                        ],
                        1
                      )
                    ],
                    2
                  )
                ]
              )
            ]),
            _c(
              "el-form-item",
              {
                attrs: {
                  label: "抄送人",
                  prop: "copyToName",
                  rules: _vm.rules.copyToName
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "inline", position: "relative" } },
                  [
                    _vm._l(_vm.copyToMembers, function(v, index) {
                      return _c(
                        "flow",
                        {
                          key: index,
                          attrs: { model: v, hiddenArrow: false },
                          on: {
                            handleClickFlowRemove: _vm.handleClickCopyRemove
                          }
                        },
                        [
                          _c(
                            "div",
                            { attrs: { slot: "username" }, slot: "username" },
                            [
                              _c(
                                "span",
                                { staticStyle: { color: "#aaaaaa" } },
                                [_vm._v(_vm._s(v.partyName))]
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { attrs: { slot: "update" }, slot: "update" },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "custom-a",
                                  attrs: { href: "javascript:void(0);" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleClickCopyUpdate(v)
                                    }
                                  }
                                },
                                [_vm._v("修改")]
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    _c("plus", {
                      on: { handleClickFlowPlus: _vm.handleClickCopyPlus }
                    })
                  ],
                  2
                )
              ]
            ),
            _c(
              "el-form-item",
              { attrs: { label: "已授权成员", prop: "dingTalkUserIds" } },
              [
                _c(
                  "ul",
                  { staticClass: "custom-inline" },
                  [
                    [
                      _c(
                        "li",
                        { staticClass: "both" },
                        [
                          _c("plus", {
                            on: { handleClickFlowPlus: _vm.initMemberForm }
                          })
                        ],
                        1
                      ),
                      !_vm.approvalModel.dingTalkUserIds.length && !_vm.isEdit
                        ? _c(
                            "li",
                            {
                              staticClass: "men-item",
                              staticStyle: { width: "60px" }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: "/images/web/p-default.png",
                                  width: "50px",
                                  height: "50px",
                                  alt: ""
                                }
                              }),
                              _c(
                                "span",
                                {
                                  staticClass: "name-warp",
                                  attrs: { title: "全体成员" }
                                },
                                [_vm._v("全体成员")]
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    _c(
                      "li",
                      { staticStyle: { "margin-top": "20px" } },
                      _vm._l(_vm.approvalModel.dingTalkUserIds, function(tag) {
                        return _c(
                          "el-tag",
                          {
                            key: tag.name,
                            staticStyle: {
                              margin: "0 10px",
                              "margin-bottom": "10px"
                            },
                            attrs: { type: "danger", closable: "" },
                            on: {
                              close: function($event) {
                                return _vm.tagRemove(tag)
                              }
                            }
                          },
                          [_vm._v(_vm._s(tag.name))]
                        )
                      }),
                      1
                    )
                  ],
                  2
                )
              ]
            )
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "选择抄送人",
              visible: _vm.visibleDialogSelectCopy,
              width: "800px"
            },
            on: {
              "update:visible": function($event) {
                _vm.visibleDialogSelectCopy = $event
              }
            }
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 24 } }, [
                  _c(
                    "section",
                    [
                      _c(
                        "el-form",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            "text-align": "right"
                          },
                          attrs: {
                            inline: true,
                            size: "small",
                            model: _vm.filterModel
                          }
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  placeholder: "邮箱/手机号",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filterModel.targetId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filterModel, "targetId", $$v)
                                  },
                                  expression: "filterModel.targetId"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c("el-input", {
                                staticStyle: { width: "150px" },
                                attrs: {
                                  placeholder: "签署方名称",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filterModel.corpUserName,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filterModel,
                                      "corpUserName",
                                      $$v
                                    )
                                  },
                                  expression: "filterModel.corpUserName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: { placeholder: "请选择部门" },
                                  model: {
                                    value: _vm.filterModel.corpGroupId,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.filterModel,
                                        "corpGroupId",
                                        $$v
                                      )
                                    },
                                    expression: "filterModel.corpGroupId"
                                  }
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "全部", value: "" }
                                  }),
                                  _vm._l(_vm.memberGroups, function(item, i) {
                                    return _c("el-option", {
                                      key: i,
                                      attrs: {
                                        label: item.groupName,
                                        value: item.corpGroupId
                                      }
                                    })
                                  })
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticStyle: { "margin-right": "0px" } },
                            [
                              _c(
                                "el-button",
                                { on: { click: _vm.handleClickSearchManager } },
                                [_vm._v("查询")]
                              ),
                              _c(
                                "el-button",
                                { on: { click: _vm.approvalReset } },
                                [_vm._v("重置")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "custom-table-style",
                          staticStyle: { padding: "0px" },
                          attrs: { span: 24 }
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: {
                                border: "1px solid #cbcbcb",
                                "border-bottom": "0"
                              },
                              attrs: {
                                data: _vm.tableSetManager,
                                "tooltip-effect": "dark",
                                "highlight-current-row": "",
                                "cell-style": { cursor: "pointer" },
                                "header-cell-style": {
                                  background: "#f9f9f9",
                                  color: "#333333",
                                  fontWeight: "500"
                                }
                              },
                              on: { "row-click": _vm.handleClickRow }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "邮箱/手机号",
                                  prop: "targetId",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "名称",
                                  prop: "userName",
                                  "show-overflow-tooltip": ""
                                }
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "部门",
                                  prop: "groupNames",
                                  "show-overflow-tooltip": ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticClass: "page-flex-end",
                          staticStyle: {
                            padding: "30px 0",
                            position: "relative"
                          },
                          attrs: { span: 24 }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.filterModel.itemPage,
                              "page-sizes": [10, 20, 50, 100],
                              "page-size": _vm.filterModel.pageSize,
                              layout: "sizes, prev, pager, next, total",
                              total: _vm.filterModel.pageTotal
                            },
                            on: {
                              "size-change": _vm.handleSizeChange,
                              "current-change": _vm.handleCurrentChange
                            }
                          }),
                          _c("el-go", {
                            staticStyle: { right: "0" },
                            attrs: {
                              "page-size": _vm.filterModel.pageSize,
                              total: _vm.filterModel.pageTotal
                            },
                            on: { "current-change": _vm.handleCurrentChange }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            ),
            _c(
              "span",
              {
                staticClass: "dialog-footer",
                attrs: { slot: "footer" },
                slot: "footer"
              },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini" },
                    on: {
                      click: function($event) {
                        _vm.visibleDialogSelectCopy = false
                      }
                    }
                  },
                  [_vm._v("取 消")]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "primary" },
                    on: {
                      click: function($event) {
                        return _vm.handleSelectCopyOk()
                      }
                    }
                  },
                  [_vm._v("确 定")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "footer", staticStyle: { "text-align": "right" } },
      [
        _c(
          "el-button",
          { attrs: { size: "mini" }, on: { click: _vm.approvalCancel } },
          [_vm._v("取消")]
        ),
        _c(
          "el-button",
          {
            staticStyle: { "margin-right": "50px" },
            attrs: { size: "mini", type: "danger" },
            on: { click: _vm.approvalOk }
          },
          [_vm._v("确定")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8078fb86", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8078fb86","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/console/dingComponents/Approval.vue
// module id = cw7z
// module chunks = 109